const flatRequestPages = (obj) =>
  obj?.pages?.reduce((acc, curr) => {
    return [...acc, ...curr.data];
  }, []) || [];

export default flatRequestPages;
